import { render, staticRenderFns } from "./PrimaryGoal.vue?vue&type=template&id=045bbd90&scoped=true&"
import script from "./PrimaryGoal.vue?vue&type=script&lang=js&"
export * from "./PrimaryGoal.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryGoal.vue?vue&type=style&index=0&id=045bbd90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045bbd90",
  null
  
)

export default component.exports